<nb-user class="{{classInk}}" [size]="size" [name]="name" [title]="title" [color]="backgroundColor" [picture]="imageUrl"  [onlyPicture]="onlyPicture">
</nb-user>
